import { Box } from '@mui/material';
import { fetchAllClientsThunk } from '../../redux/thunks/client';
import NavbarComponent from '../../components/reusable/navbar';
import { useEffect } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Outlet, useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

const ClientPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { isSales, currentUser } = useSelector((state: RootState) => state.app);

    useEffect(() => {
        if (!isSales && currentUser?.role !== 'client') {
            navigate('/app/dashboard');
        }
    }, [isSales]);

    useEffect(() => {
        const fetchAllClients = async () => {
            try {
                const roleExist = ['organizationOwner', 'organizationAdmin', 'companyManager'].includes(currentUser?.role as string);
                if (roleExist) {
                    await dispatch(fetchAllClientsThunk()).unwrap();
                }
            } catch (e) {
                // Catch errors
            }
        };
        fetchAllClients();
    }, []);

    return <Box>
        <NavbarComponent />
        <Box p={2}>
            <Outlet />
        </Box>
    </Box>;
};

export default ClientPage;